import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setData(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 6) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="container-x py-24 text-center max-w-xl" data-testid="payment-success-page">
      {status === "paid" ? (
        <>
          <CheckCircle2 size={56} className="text-[#0D2C4D] mx-auto mb-6" />
          <h1 className="text-4xl font-light mb-3">Paiement confirmé</h1>
          <p className="text-muted-foreground mb-8">Votre réservation est maintenant validée. Vous pouvez retrouver tous les détails dans votre espace client.</p>
        </>
      ) : status === "checking" || status === "pending" ? (
        <>
          <h1 className="text-3xl font-light mb-3">Vérification du paiement…</h1>
          <p className="text-muted-foreground">Cela peut prendre quelques secondes.</p>
        </>
      ) : (
        <>
          <h1 className="text-3xl font-light mb-3">Statut indisponible</h1>
          <p className="text-muted-foreground mb-8">Veuillez vérifier votre espace client.</p>
        </>
      )}
      <Button asChild className="bg-[#2B8B8E] hover:bg-[#1F6F73] text-white rounded-full px-8" data-testid="back-to-account">
        <Link to="/mon-compte">Voir mes réservations</Link>
      </Button>
    </div>
  );
}
